import React from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { UI } from "@wwimmo/ui";
import styles from "./NewsPublishfromModal.module.css";
import { getDate } from "src/utils/Date";

interface NewsPublishfromModalProps {
    publishfrom: string;
    isNewsSaved: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const NewsPublishfromModalBase = ({ publishfrom, isNewsSaved, onClose, onConfirm }: NewsPublishfromModalProps) => {
    const { t } = useTranslation();

    return (
        <UI.Modal
            show={true}
            onClose={onClose}
            isScrollable={true}
            title={t("screens.realestate.news_edit.terminieren_title").toString()}
            className={styles.NewsPublishfromModal}
        >
            {isNewsSaved ? (
                <div>
                    {t("screens.realestate.news_edit.terminiert_message", {
                        publishedDate: getDate(publishfrom)
                    })}
                </div>
            ) : (
                <>
                    <div>
                        {t("screens.realestate.news_edit.unset_message", {
                            publishedDate: getDate(publishfrom)
                        })}
                    </div>
                    <div className={styles.DivModalButton}>
                        <UI.Button
                            label={t("labels.no")}
                            variant="outline-primary"
                            onClick={onClose}
                            className={`${styles.CancelButton} mt-3`}
                        />
                        <UI.Button label={t("labels.yes")} onClick={onConfirm} className={`${styles.AddButton} mt-3`} />
                    </div>
                </>
            )}
        </UI.Modal>
    );
};

export const NewsPublishfromModal = Sentry.withProfiler(observer(NewsPublishfromModalBase));
